/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Text_To_Upper_CaseInputs */



/**
* | output |
* | --- |
* | "Text to Upper Case" |
*
* @param {Text_To_Upper_CaseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const text_to_upper_case = /** @type {((inputs?: Text_To_Upper_CaseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Text_To_Upper_CaseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Texte en majuscules")
	if (locale === "de") return /** @type {LocalizedString} */ ("Text in Großbuchstaben umwandeln")
	if (locale === "it") return /** @type {LocalizedString} */ ("Testo in maiuscolo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Текст в верхнем регистре")
	if (locale === "es") return /** @type {LocalizedString} */ ("Texto a mayúsculas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文本转换为大写")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキストを大文字にする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेक्स्ट को अपर केस में बदलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Texto em maiúsculas")
	return /** @type {LocalizedString} */ ("Text to Upper Case")
});